import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  width: 100%;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  background-color: ${({ theme }) => theme.neutral_500};
  color: ${({ theme }) => theme.neutral_100};
  border-radius: 0px 8px 8px 0px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.neutral_300};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
